import { render, staticRenderFns } from "./CommissionGiveDetails.vue?vue&type=template&id=429a53f6&scoped=true"
import script from "./CommissionGiveDetails.vue?vue&type=script&lang=js"
export * from "./CommissionGiveDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429a53f6",
  null
  
)

export default component.exports